import { css } from "@linaria/core";
import {
  units,
  outline,
  colors,
  fonts,
  easings,
  surfaces,
  postloadedImageSelectors,
} from "@pm2/compat";

export const list = css`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  list-style: none;

  &[data-type="dots"],
  &[data-type="numbered"] {
    position: absolute;
    left: ${units.px(30)};
    right: ${units.px(30)};
    bottom: ${units.px(15)};
  }

  &[data-type="thumb"] {
    margin-top: ${units.px(10)};
  }
`;

export const button = css`
  ${outline({ borderRadius: "50%" })};

  padding: ${units.px(3)};
`;

export const bullet = css`
  &[data-type="numbered"],
  &[data-type="dots"] {
    box-sizing: border-box;
    height: ${units.px(13)};
    width: ${units.px(13)};

    background-color: ${colors.gray.sim15()};
    border-radius: 50%;

    white-space: nowrap;

    display: flex;
    justify-content: center;
    align-items: center;

    font-family: ${fonts.body({ weight: "medium" })};
    font-size: ${units.font.px(13)};
    line-height: ${fonts.lineHeight(1)};
    color: ${colors.gray.sim65()};

    transition: color 0.1s linear, background-color 0.1s linear,
      border-color 0.1s linear, transform 0.1s ${easings.outQuad};

    &:hover {
      background: ${surfaces.gray.sim100()};
    }

    &:active:not(.active) {
      transform: scale(0.95);
    }

    &.active {
      background-color: ${colors.black()};

      &[data-type="numbered"] {
        background: ${surfaces.gray.sim100()};
        border-color: ${colors.black()};
      }
    }
  }

  /* stylelint-disable-next-line no-descending-specificity */
  &[data-type="numbered"] {
    padding-inline: ${units.px(5)};

    height: ${units.px(20)};
    width: max-content;
    min-width: ${units.px(20)};

    background-color: ${colors.gray.sim00()};
    border: ${units.px(1)} solid ${colors.gray.sim10()};
    border-radius: ${units.px(10)};
  }

  &[data-type="thumb"] {
    border: ${units.px(2)} solid transparent;
    border-radius: ${units.px(4)};

    display: block;

    opacity: 0.2;
    transition: opacity 0.1s linear, box-shadow 0.1s linear,
      border-color 0.1s linear;

    & ${postloadedImageSelectors.image()} {
      height: ${units.px(50)};
      border-radius: ${units.px(4)};
    }

    &:hover,
    &:focus-visible {
      opacity: 0.9;
    }

    &.active {
      box-shadow: 0 0 ${units.px(2)} rgba(0 0 0 / 0.25);
      border-color: #fff;

      opacity: 1;
    }
  }
`;
